import { useSelector } from 'react-redux'
import { useIntl, defineMessages } from 'react-intl'
import { RootState } from '../../../../../../types/rootState'
import { Heading } from '@homebotapp/hb-react-component-catalog'
import { formatCurrency } from '../../../../../../helpers/formatters'

export const MSG = defineMessages({
  savings: {
    id: 'Pmi.pmiDetailsText.potentialSavings',
    defaultMessage: 'Potential savings'
  }
})

export const CanRemovePmiDetailsHeader = () => {
  const intl = useIntl()
  const savings = useSelector<RootState, number | null>(state => state.pmi.totalPmiSavingsInDollars)

  return (
    <>
      <Heading as='h4' size='xs' variant='eyebrow' color='neutral-700'>
        {intl.formatMessage(MSG.savings)}
      </Heading>
      <Heading as='h3' size='lg' color='success' textAlign='left' fontWeight='semibold'>
        {formatCurrency(savings)}
      </Heading>
    </>
  )
}
